<template>
    <div class="gap-row-xs" v-if="passwordScore !== -1">
        <div class="qrw-paragraph-xs bold w-100 password-score-text" :class="commentClass">
            {{ $t('password_scores.'+passwordScore) }}
        </div>
        <div class="meter-bar gap-column-1xs">
            <div class="meter-bar-item" :style="getStyleForBarItem(n-1)" v-for="n in 10" :key="n"></div>
        </div>
    </div>
</template>

<script>
import zxcvbn from 'zxcvbn'

export default {
    props: {
        value: String
    },
    watch: {
        passwordScore() {
            this.$emit('score', this.passwordScore);
        }
    },
    methods: {
        getStyleForBarItem(index) {
            const requiredScoreMapping = [
                0,0,1,1,2,2,3,3,4,4
            ];

            const required_score = requiredScoreMapping[index];

            if (this.passwordScore < required_score) return {};

            return {
                'background-color': `var(--${this.passwordScoreColor}-color)`
            }
        }
    },
    computed: {
        passwordScoreColor() {
            if (this.passwordScore < 2) return 'red-4';
            if (this.passwordScore < 3) return 'orange-4';
            
            return 'green-5';
        },
        commentClass() {
            return `${this.passwordScoreColor}-color`;
        },
        passwordScore() {
            if (!this.value) return -1;

            const result = zxcvbn(this.value);

            return result.score;
        }
    }
}
</script>

<style scoped>
.meter-bar-item {
    width: 100%;
    border-radius: 8px;
    height: 2px;

    background: var(--v1-grey-4-color);
}

.password-score-text {
    text-align: center;
}
</style>